// const HOST1 = "https://organizations.ottomatically.com/api/v1/"
// const HOST1 = "https://linked-things-s4-organizations.eu-de.mybluemix.net/api/v1/";
const HOST1 = 'https://organizations.ottomatically.com/api/v1/';                                 //VM
// const HOST = 'localhost:3000/api/v1';                                   //Local 

export default {
    HOST1
}